import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

const CancellationAndRefund = () => {
  return (
    <section className="min-h-screen w-screen bg-gradient-to-b from-[#fefef8] to-[#fafae0] flex flex-col items-center Poppins">
      <Navbar />

      <div className="pt-[60px] w-full flex justify-center px-6">
        <div className="max-w-7xl w-full bg-white shadow-lg rounded-2xl border border-yellow-300 p-6 lg:p-10">
          <h1 className="text-3xl lg:text-4xl font-extrabold text-gray-800 text-center mb-6 tracking-wide">
            Cancellation and Refund Policy
          </h1>
          <p className="text-center text-gray-500 mb-8">
            Last updated: <span className="font-medium">July 2026</span>
          </p>

          <div className="space-y-8 text-gray-700 leading-relaxed">
            <p>
              At <span className="font-semibold">INSTAPORT DELIVERY</span>, our focus is complete customer satisfaction. In the event you are displeased with the services provided, we will refund your money, provided the reasons are genuine and verified after investigation. Please read the details of each service before purchasing, as they provide comprehensive information about the services you acquire.
            </p>
            <p>
              If you are dissatisfied with our services, you have the liberty to cancel your order and request a refund. Our cancellation and refund policies are outlined below:
            </p>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                Cancellation Policy
              </h2>
              <ul className="list-disc list-inside space-y-2">
                <li>Customers can cancel an order at any time before it has been initiated or completed by the courier.</li>
                <li>Order initiation is defined as the courier reaching the pickup point as per the order schedule. In such cases, only a partial refund can be provided.</li>
                <li>Order completion is defined as the courier visiting the pickup and at least one delivery location within the order schedule. In such instances, a refund cannot be initiated.</li>
                <li>Customers can cancel orders using the cancellation options in the app or directly from the dashboard of their registered account on our web portal.</li>
                <li>For cancellations with the help of a Customer Support agent, please contact us via chat on the website or app. Our specialists will attend to your requests during working hours, subject to availability and as per Customer Support guidelines.</li>
              </ul>
              <p className="mt-4">
                Cancellation fees will apply to orders that were initiated or fully/partially completed as follows:
              </p>
              <ul className="list-disc list-inside space-y-2 mt-2">
                <li>If the courier has completed the pickup, reached the pickup address within the scheduled time, or arrived at the pickup address up to 30 minutes prior and notified the customer, the cancellation fee will be equal to the pickup charges of the scheduled order.</li>
                <li>For cash payments, cancellation charges will be debited from the customer’s Instaport Delivery balance as a credit note and applied to the next order placed.</li>
                <li>For non-cash payment modes, cancellation charges will be directly debited from the customer’s Instaport Delivery prepaid/postpaid balance, reflected in the customer dashboard and the invoice for the period as a cancellation fee. The fee will be applied to the same order number that was cancelled.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                Refund Policy
              </h2>
              <p>
                Upon confirmation from our investigation team and their positive feedback, the refund will be credited either to the customer’s Instaport Delivery balance as a credit note or directly to the customer’s bank account within 7 working days, based on the customer’s preference.
              </p>
              <p className="mt-2">
                Liability for goods being delivered is limited to the guaranteed amount, provided the customer has declared the true cost and correct contents of the parcel during order placement on the portal, and only if the security fee of 0.85% plus GST on the declared cost is paid prior to order placement. The maximum liability, within the maximum allowed guarantee amount, is 20,000 rupees. Under no circumstances should customers place orders with a value exceeding 20,000 rupees without prior written confirmation from the Instaport Delivery management team.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                Contact Us
              </h2>
              <p>
                For any disputes or questions, please reach us via our support page or contact our Grievance Officer:
              </p>
              <div className="mt-2 bg-gray-50 p-4 rounded-lg shadow-sm text-sm">
                <p>
                  <span className="font-medium">Address:</span> R/3 A Wing ground floor Mass Metropolis Chembur Mumbai Maharashtra 400071
                </p>
                <p>
                  <span className="font-medium">Email:</span> support@instaportdelivery.com
                </p>
                <p>
                  <span className="font-medium">Working Hours:</span> Mon–Sat : 
                  10am – 8pm, Sun : 10am - 6pm
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </section>
  );
};

export default CancellationAndRefund;